export default {

    setMenuItems(state, payload) 
    {
        state.menu.items = payload || false
    },

    setMenuOpened(state, payload) 
    {
        state.menu.opened = payload || false
    },

    setSubmenuOpened(state, payload) 
    {
        state.menu.submenu = payload || false
    },

    setUserData(state, { name, type = 'name'}) 
    {
        if ( state.user ) {
            name && name.length > 1 && (state.user.name = name)
            type && type.length > 1 && (state.user.type = type)
        }
    },
    
    setUserStorage(state, { name, type })
    {
        if ( !localStorage ) return;

        name && localStorage.setItem('userName', name)
        type && localStorage.setItem('userType', type)
    },  

    setVisibleStories(state, payload)
    {
        state.visible.stories = payload
    },

}
